import { render, staticRenderFns } from "./TeamTreeNode.vue?vue&type=template&id=f0c80996"
import script from "./TeamTreeNode.vue?vue&type=script&lang=js"
export * from "./TeamTreeNode.vue?vue&type=script&lang=js"
import style0 from "./TeamTreeNode.vue?vue&type=style&index=0&id=f0c80996&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports